export const StaticImages = {
    EARN: 'earn',
    GPAY: 'Gpay',
    STAR: 'Star',
    LOGO: 'logo',
    VISA: 'Visa',
    ADGEM: 'AdGem',
    BONUS: 'Bonus',
    TOROX: 'Torox',
    VERIFY: 'verify',
    AMAZON: 'Amazon',
    PAYPAL: 'Paypal',
    STRIPE: 'Stripe',
    OFFERS: 'offers',
    WANNADS: 'Wannads',
    COINBAG: 'CoinBag',
    INBRAIN: 'InBrain',
    TWITTER: 'Twitter',
    SPOTIFY: 'Spotify',
    SUPPORT: 'support',
    PROFILE: 'profile',
    NETFLIX: 'Netflix',
    REWARDS: 'rewards',
    LOOTABLY: 'Lootably',
    BITLABS: 'BitLabs',
    TIMEWALL: 'TimeWall',
    FACEBOOK: 'Facebook',
    GREYSTAR: 'GreyStar',
    STAR_SVG: 'Star_svg',
    TASKTILE: 'TaskTile',
    PAYONEER: 'Payoneer',
    TUTORIAL: 'tutorial',
    POLLFISH: 'Pollfish',
    SETTINGS: 'settings',
    REFFERAL: 'refferal',
    ADGATE: 'AdGatemedia',
    SHAREICON: 'ShareIcon',
    VERIFYOTP: 'VerifyOTP',
    USER_PLUS: 'user-plus',
    AMAZONBIG: 'AmazonBig',
    PERSONALY: 'Personaly',
    GREENBOLT: 'GreenBolt',
    REWARDSCUP: 'RewardsCup',
    COINMASTER: 'CoinMaster',
    FOLLOWICON: 'FollowIcon',
    OFFERWALLS: 'offerwalls',
    PROFILEPIC: 'ProfilePic',
    GOOGLEPLAY: 'GooglePlay',
    ADGATEMEDIA: 'AdGatemedia',
    AYETSTUDIOS: 'AyetStudios',
    CPXRESEARCH: 'CPXResearch',
    POUCHICON:'MoneyPouchIcon',
    DAILYCHECKIN: 'DailyCheckin',
    ADSCENDMEDIA: 'AdscendMedia',
    PRIMARYCHECK: 'PrimaryCheck',
    GREYSTAR_SVG: 'GreyStar_svg',
    SPINTHEWHEEL: 'SpinTheWheel',
    SHAREACTIVITY: 'ShareActivity',
    SHAREONTIKTOK: 'ShareOnTikTok',
    INVITEFRIENDS: 'InviteFriends',
    MONEYOUCHICON: 'MoneyPouchIcon',
    SHAREONTWITTER: 'ShareOnTwitter',
    SHAREONYOUTUBE: 'ShareOnYouTube',
    CONTROLLERICON: 'ControllerIcon',
    FAQBANNERCLOCK: 'FaqBannerClock',
    INVITE_FRIENDS: 'invite-friends',
    LIKEONFACEBOOK: 'LikeOnFacebook',
    FOLLOWONTIKTOK: 'FollowOnTikTok',
    FAQBANNERITEM2: 'FAQBannerItem2',
    SHAREONWHATSAPP: 'ShareOnWhatsApp',
    VERIFYOTP_STARS: 'VerifyOTP_Stars',
    FOLLOWONTWITTER: 'FollowOnTwitter',
    HOMEBANNERITEM1: 'HomeBannerItem1',
    HOMEBANNERITEM2: 'HomeBannerItem2',
    HOMEBANNERITEM3: 'HomeBannerItem3',
    SHAREONINSTAGRAM: 'ShareOnInstagram',
    SHAREONMESSENGER: 'ShareOnMessenger',
    FOLLOWONFACEBOOK: 'FollowOnFacebook',
    GREENUPWARDARROW: 'GreenUpwardArrow',
    VERIFYOTP_TOOLTIP: 'VerifyOTP_ToolTip',
    ENTERREFERRALCODE: 'EnterReferralCode',
    OFFERGENERICIMAGE: 'OfferGenericImage',
    FOLLOWONINSTAGRAM: 'FollowOnInstagram',
    DAILYCHECKINDIALOG: 'DailyCheckinDialog',
    FAQBANNERCELLPHONE: 'FaqBannerCellphone',
    OFFERGENERICIMAGE1: 'OfferGenericImage1',
    REFERRALBANNERWING: 'ReferralBannerWing',
    VERIFICATIONCOMPLETE: 'VerificationComplete',
    VERIFYOTP_MESSAGEBOX: 'VerifyOTP_MessageBox',
    OFFERGENERICIMAGE_WEBP: 'OfferGenericImage_webp',
    REFERRALBANNERGRADIENT: 'ReferralBannerGradient',
    PAYOUTWITHDRAWALFAILED: 'PayoutWithdrawalFailed',
    INSTALLAPPWITHREFERRAL: 'InstallAppWithReferral',
    VERIFYPHONENUMBERDIALOG: 'VerifyPhoneNumberDialog',
    REFERRALBANNERBACKGROUND: 'ReferralBannerBackground',
    PAYOUTWITHDRAWLSUCCESSFULL: 'PayoutWithdrawlSuccessfull',
    HANDWITHGOLDENCOINSLYINGPALM: 'HandWithGoldenCoinsLyingPalm',
    LOGINCOINBACKGROUND: 'LoginCoinBackground',
    LOGINPERSON: 'LoginPerson',
    LOGINCOINMOBILE: 'LoginCoinMobile',
    GREENCHECKMARK: 'GreenCheckmark',
    GREENCIRCLE: 'GreenCircle',
};
